import { mapState, mapActions } from 'vuex'

export default {
  name: 'HandoffMixin',
  computed: {
    ...mapState([ 'cart' ]),
    ...mapState({
      vehicleInfo: state => state.locations.vehicleInfo,
      deliveryAddress: state => state.locations.deliveryAddress,
    }),
  },
  methods: {
    ...mapActions([ 'getCart', 'getDeliveryLocations', 'hideCart' ]),
    ...mapActions({
      applyCartHandoff: 'checkout/applyCartHandoff',
    }),
    isCateringPage() {
      return this.$route.fullPath.includes('catering')
    },
    setReservation() {
      return this.redirectToLocationSearch()
    },
    setAnnex() {
      this.applyCartHandoff({ handoffMode: 'annex' })
    },
    setPickup() {
      this.applyCartHandoff({ handoffMode: 'pickup' })
    },
    setDrivethru() {
      this.applyCartHandoff({ handoffMode: 'drivethru' })
    },
    async setDelivery() {
      if (this.deliveryAddress) {
        const location = await this.getDeliveryLocations({
          address: this.deliveryAddress.address,
          city: this.deliveryAddress.city,
          zip: this.deliveryAddress.zip,
        })

        if (location === null) {
          return this.redirectToLocationSearch()
        }

        await this.applyCartHandoff({
          address: this.deliveryAddress.address,
          building: this.deliveryAddress.building,
          city: this.deliveryAddress.city,
          state: this.deliveryAddress.state,
          zip: this.deliveryAddress.zip,
          phone: this.deliveryAddress.phone,
          instructions: this.deliveryAddress.instructions,
          default: false,
          handoffMode: 'delivery',
        })
        
        if (!this.cart) {
          await this.getCart()
        }
      }

      if (this.cart && this.cart.address === null) {
        return this.redirectToLocationSearch()
      }
    },
    async setCurbside() {
      if (this.vehicleInfo) {
        await this.applyCartHandoff({
          Make: this.vehicleInfo.make,
          Model: this.vehicleInfo.model,
          Color: this.vehicleInfo.color,
          handoffMode: 'curbside',
        })

        if (!this.card) {
          await this.getCart()
        }
      }

      if (this.cart) {
        if (!this.cart.custom) {
          return this.redirectToLocationSearch()
        }

        // checks for make, model and color in the cart
        const shouldRedirect = this.cart.custom.find(custom => {
          return custom.scope === 'curbsidepickupordersonly' && custom.isrequired && !custom.value
        })
        if (shouldRedirect) {
          return this.redirectToLocationSearch()
        }
      }
    },
    redirectToLocationSearch() {
      document.body.style.overflow = 'auto'
      this.hideCart();
      this.$router.push(this.isCateringPage() ? '/catering' : '/locations')
    },
  }
}
